import React from 'react';
import { S } from './DownloadReportButton.styles';
import { toast } from '../../../../../../components/Toast';
import { BackgroundControlWithFilesRiskEnum } from '@ansvar-sakerhet/api-client';
import { useDownloadBGFile } from '../../../../../../traits/api/controls/useDownloadBGFile';

export const DownloadReportButton = ({
  risk,
  backgroundControlId,
  fileName,
}: {
  risk: BackgroundControlWithFilesRiskEnum;
  backgroundControlId: string;
  fileName?: string;
}) => {
  const downloadFile = useDownloadBGFile(backgroundControlId);

  const startDownload = async (event: React.MouseEvent) => {
    event.stopPropagation();

    if (!backgroundControlId) {
      return toast.error('Fil kunde inte hittas');
    }

    const blob = await downloadFile();
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = fileName || 'rapport';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
  };

  return (
    <S.Wrapper>
      {fileName && <S.FileNameLabel>{fileName}</S.FileNameLabel>}
      <S.DownloadButton onClick={startDownload} $noRisks={risk}>
        <S.IconWithBg src="Draft" /> Ladda ner rapport
      </S.DownloadButton>
    </S.Wrapper>
  );
};
